import "core-js/stable";
import "regenerator-runtime/runtime";
import { gsap } from "gsap";

var ua = navigator.userAgent;
var isIE = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

function toggleMenu() {
  const menuToggler = document.querySelector(".menu-toggler");
  const languageSwitcher = document.querySelector(".language-switcher");
  const isOpening = menuToggler.classList.contains("active");
  if (isOpening) {
    menuToggler.setAttribute("aria-label", "Open menu");
    menuToggler.setAttribute("aria-expanded", "false");
  } else {
    menuToggler.setAttribute("aria-label", "Close menu");
    menuToggler.setAttribute("aria-expanded", "true");
  }
  languageSwitcher.classList.toggle("active");
  menuToggler.classList.toggle("active");
  document.querySelector("#header-menu").classList.toggle("active");
}

function toggleVideoVolume() {
  const video = document.querySelector(".hero-video");
  const volumeButton = document.querySelector(".volume-button");
  const isMuting = volumeButton.classList.contains("active");
  const volumeIconPath = volumeButton.querySelector("path");
  if (isMuting) {
    video.muted = true;
    volumeIconPath.setAttribute(
      "d",
      "M1 6.716h7.217v11.469H1zM20.806 23.901L8.217 18.006V6.538l12.589-5.537zM26.603 9.149l6.603 6.603M33.408 9.149l-6.603 6.603"
    );
  } else {
    video.muted = false;
    volumeIconPath.setAttribute(
      "d",
      "M1 6.716h7.217v11.469H1zM20.806 23.901L8.217 18.006V6.538l12.589-5.537z"
    );
  }
  volumeButton.classList.toggle("active");
}

function arrangeGrid(columns, gridNodeChildren) {
  const fixedColumns = isIE ? columns + 2 : columns;
  let currentColumn = 1;
  let currentRow = 1;
  let reverse = false;
  for (let index = 0; index < gridNodeChildren.length; index++) {
    const gridElement = gridNodeChildren[index];
    if (isIE) {
      gridElement.style["-ms-grid-row"] = currentRow;
      gridElement.style["-ms-grid-column"] = currentColumn;
    } else {
      gridElement.style.gridRow = currentRow;
      gridElement.style.gridColumn = currentColumn;
    }
    // Next row with reversed order
    if (
      (currentColumn % fixedColumns === 0 && !reverse) ||
      (currentColumn % fixedColumns === 1 && reverse)
    ) {
      if (isIE) {
        currentRow += 2;
      } else {
        currentRow++;
      }
      reverse = !reverse;
      continue;
    }
    if (isIE) {
      reverse ? (currentColumn -= 2) : (currentColumn += 2);
    } else {
      reverse ? currentColumn-- : currentColumn++;
    }
  }
}

window.addEventListener("DOMContentLoaded", function() {
  document.querySelector(".menu-toggler").addEventListener("click", toggleMenu);
  document.querySelector("#header-menu").addEventListener("click", function(e) {
    if (e.target.classList.contains("nav-link")) {
      toggleMenu();
    }
  });

  document
    .querySelector(".volume-button")
    .addEventListener("click", toggleVideoVolume);

  // Scroll to id element
  const anchors = document.querySelectorAll("a[href*='#']");
  anchors.forEach(anchor =>
    anchor.addEventListener("click", function(e) {
      e.preventDefault();
      const link = anchor.href.match(/#.*/)[0];
      document.querySelector(link).scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    })
  );
  // Resize footer elements to be equal so the logo stays in the middle
  document.querySelector(".footer-media").style.width =
    document.querySelector(".footer-privacy").clientWidth + "px";

  // Scroll to top on footer logo click
  const supportsSmoothScroll =
    "scrollBehavior" in document.documentElement.style;
  document.querySelector(".footer-logo").addEventListener("click", function() {
    if (supportsSmoothScroll) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  });

  // Arrange process-grid elements
  const processGrid = document.querySelector(".process-grid");
  if (window.innerWidth > 1100) {
    arrangeGrid(3, processGrid.children);
  } else {
    arrangeGrid(2, processGrid.children);
  }

  // Activate tags on scroll
  const offsets = [];
  for (let index = 1; index <= 4; index++) {
    offsets.push(document.querySelector(`#made-of-${index}`).offsetTop);
  }
  const allTags = document.querySelectorAll(".tag");
  const allNavLinks = document.querySelectorAll(".nav-link");

  document.addEventListener(
    "scroll",
    function() {
      let currentTag;
      for (let index = 0; index < 4; index++) {
        if (offsets[index] < window.scrollY + window.innerHeight / 2) {
          currentTag = index + 1;
        }
      }
      const currentTagNode = document.querySelector(`.tag--${currentTag}`);
      const currentNavLink = allNavLinks[currentTag - 1];
      if (currentTag && !currentTagNode.classList.contains("active")) {
        // if the active tag changes deactivate all and activate the tag
        allTags.forEach(tag => tag.classList.remove("active"));
        allNavLinks.forEach(navLink => navLink.classList.remove("active"));
        currentTagNode.classList.add("active");
        currentNavLink.classList.add("active");
      } else if (!currentTag) {
        // if no tag passes hide all
        allTags.forEach(tag => tag.classList.remove("active"));
        allNavLinks.forEach(navLink => navLink.classList.remove("active"));
      }
    },
    { passive: true }
  );

  // use .animated-section on a section that is starting animation when the user scrolls to it
  // use .animated-element on an element that is animated (staggering) in the DOM order
  const animatedSections = document.querySelectorAll(".animated-section");
  animatedSections.forEach(animatedSection => {
    const handleAnimation = () => {
      if (animatedSection.offsetTop < window.scrollY + window.innerHeight / 2) {
        animatedSection.classList.add("animated-section--done");
        gsap.fromTo(
          animatedSection.querySelectorAll(".animated-element"),
          {
            opacity: 0,
            y: 100
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2
          }
        );
        document.removeEventListener("scroll", handleAnimation);
      }
    };

    document.addEventListener("scroll", handleAnimation, { passive: true });
  });
});
